
<style scoped>
    .Page {
        margin-bottom: 1rem;
        overflow: hidden;
    }

    .Description {
        /* font-style: italic; */
        /* font-weight: 600; */
        line-height: 1.5;
    }

    .Description >>> a,
    .Description >>> a:visited {
        font-weight: 600;
        /* color: #2c3e50; */
        color: hsl(0, 100%, 71%);
        /* color: hsl(0, 100%, 69%); */
    }

    .Description >>> a:hover {
        color: hsl(0, 100%, 76%);
    }
</style>


<template lang="pug">

//- .Page
    fieldset

        //- legend( v-if="data.title" ) &nbsp;{{ index }}: {{ data.title }}&nbsp;

        legend
            Steps( :step="form.step" :steps="form.steps-1" :title="data.title" )

        //- p {{ data.description }}
        p( v-html="data.description" )

        //- component( v-if="component" :is="component" :index="index" :type="type" :name="name" :label="label" :placeholder="placeholder" :items="items" )

        component( v-if="data.component" :is="data.component" :index="index" :data="data" )

        //- hr


.Page
  
    p.Description( v-html="data.description" )

    component( v-if="data.component" :is="data.component" :index="index" :data="data" )


</template>


<script>

import { defineComponent, reactive, } from 'vue'

import useState from '../state'

import Steps from './Steps.vue'
import MultipleChoice from './MultipleChoice.vue'
import ShortText from './ShortText.vue'

export default defineComponent( {

    name: 'Page',

    components: {
        Steps, MultipleChoice, ShortText,
    },

    props: ['index', 'data', /*'title', 'description', 'component', 'type', 'name', 'items', 'label', 'placeholder'*/],

    setup( props ) {

        const { form } = useState()


        return {
            form,
        }

    },

} )
</script>